import { render, staticRenderFns } from "./cltx.vue?vue&type=template&id=6e13356a&scoped=true&"
import script from "./cltx.vue?vue&type=script&lang=js&"
export * from "./cltx.vue?vue&type=script&lang=js&"
import style0 from "./cltx.vue?vue&type=style&index=0&id=6e13356a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13356a",
  null
  
)

export default component.exports